
    <ng-container #entryPoint></ng-container>
    <fl-modal></fl-modal>
  


// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/th/webapp/src/compat/compat.component.ts.CompatComponent.html